var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { applyHyphens, applySpacing } from '../mixins';
import { bodyL, bodyLBold, bodyM, bodyMBold, bodyS, bodySBold, bodyXS, bodyXSBold, bodyXXS, bodyXXSBold, } from '../tokens';
export var BodyL = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n"])), applyHyphens, applySpacing, function (_a) {
    var bold = _a.bold;
    return (bold ? bodyLBold : bodyL);
});
export var BodyM = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n"])), applyHyphens, applySpacing, function (_a) {
    var bold = _a.bold;
    return (bold ? bodyMBold : bodyM);
});
export var BodyS = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n"])), applyHyphens, applySpacing, function (_a) {
    var bold = _a.bold;
    return (bold ? bodySBold : bodyS);
});
export var BodyXS = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n"])), applyHyphens, applySpacing, function (_a) {
    var bold = _a.bold;
    return (bold ? bodyXSBold : bodyXS);
});
export var BodyXXS = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n"])), applyHyphens, applySpacing, function (_a) {
    var bold = _a.bold;
    return (bold ? bodyXXSBold : bodyXXS);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Body.js.map